import { useContext, useState } from 'react';
import { useCart } from 'src/hooks/useCart';
import { useModal } from 'src/hooks/useModal';
import { useShopSelector } from 'src/hooks/useShopSelector';
import { I18nContext } from 'src/stores/I18n';

export const useShopChange = () => {
  const { cart } = useCart();
  const localeResources = useContext(I18nContext);
  const { currentShop, changeShopHandler } = useShopSelector();
  const { setIsVisible, ignitionSource } = useModal('shopSelectModal');
  const [currentShopId, setCurrentShopId] = useState<number | undefined>(currentShop?.id);

  const onShopChange = (id: number) => {
    setIsVisible(false);

    if (id === currentShop?.id || cart.length === 0) {
      changeShopHandler(id, ignitionSource);
      return;
    }

    const userConfirmed = confirm(
      localeResources.airports.areYouSureToSwitchAirport +
        '\n' +
        localeResources.airports.switchingAirportWouldClearCart
    );
    if (userConfirmed) {
      changeShopHandler(id, ignitionSource);
    } else {
      setCurrentShopId(currentShop?.id);
    }
  };

  return { onShopChange, currentShopId, setCurrentShopId };
};
